import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { useAuth } from './context/AuthContext';

import Login from './pages/Login';
import Register from './pages/Register';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import Translate from './pages/Translate';
import Decks from './pages/Decks';
import Practice from './pages/Practice';
import Dashboard from './pages/Dashboard';
import Profile from './pages/Profile';

import Explore from './pages/Explore';


const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading) return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100vh', background: '#0f0f23', color: 'var(--text-muted)', fontSize: '0.88rem' }}>
      Loading…
    </div>
  );
  return user ? children : <Navigate to="/login" replace />;
};

export default function App() {
  return (
    <BrowserRouter basename="/app">
      <Toaster
        position="top-center"
        toastOptions={{
          style: {
            background: '#1a1a35',
            color: '#ece8ff',
            border: '1px solid #252550',
            fontFamily: "'DM Sans', sans-serif",
            fontSize: '0.85rem',
          },
          success: { iconTheme: { primary: '#3dd68c', secondary: '#0f0f23' } },
          error: { iconTheme: { primary: '#ff5c7c', secondary: '#0f0f23' } },
        }}
      />
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/translate" element={<ProtectedRoute><Translate /></ProtectedRoute>} />
        <Route path="/decks" element={<ProtectedRoute><Decks /></ProtectedRoute>} />
        <Route path="/practice/:id" element={<ProtectedRoute><Practice /></ProtectedRoute>} />
        <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
        <Route path="/profile" element={<ProtectedRoute><Profile /></ProtectedRoute>} />
        <Route path="/explore" element={<ProtectedRoute><Explore /></ProtectedRoute>} />
        <Route path="*" element={<Navigate to="/dashboard" replace />} />
      

      </Routes>
    </BrowserRouter>
  );
}
